import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type TabInfoVariants = 'normal' | 'warning';

const variants: { [key in TabInfoVariants]: ReturnType<typeof css> } = {
  normal: css`
    background: #f5f7fa;
    border: 1px solid #f5f7fa;

    b {
      font-weight: normal;
    }
  `,
  warning: css`
    background: #fff4db;
    border: 1px solid #fcbd26;
  `
};

const wrapperOnMobiles = media.tablet`
  margin-top: 18px;
`;

export const TabInfoWrapper = styled.div<{ variant: TabInfoVariants }>`
  color: #292a2b;
  font-size: 14px;
  line-height: 22px;
  border-radius: 5px;
  padding: 10px 12px 8px;
  margin-bottom: 18px;

  a {
    text-decoration: underline;
    color: var(--blue_100);
    &:hover {
      text-decoration: none;
    }
  }

  ${wrapperOnMobiles};

  ${({ variant }) => variants[variant]}
`;
